const styles = theme => ({
  base: {
    padding: 6,
    outline: 'none',
    boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.15)',
    '&.MuiIconButton-root:focus': {
      outline: 'none',
    },
  },
  filled: {
    backgroundColor: theme.palette.secondary.main,
    color: '#fff',
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
  outlined: {
    backgroundColor: 'transparent',
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
});

export default styles;
